export enum CandidateSortableField {
  CreatedAt = 'createdAt',
  Shortlist = 'shortlist',
  Status = 'status',
  Hired = 'hired',
}
